import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import classNames from 'classnames';

type DatePickerWithPreviewProps = {
  onChange: (momentDate: any, stringDate: any) => void;
  value: string | null;
  size?: any;
  disabled?: boolean;
  allowClear?: boolean;
  tabIndex?: number;
};

const DatePickerWithPreview: React.FC<DatePickerWithPreviewProps> = ({
  onChange,
  value,
  size,
  disabled,
  allowClear,
  tabIndex,
}) => {
  const [isEditAble, setIsEditAble] = React.useState(!value || false);

  React.useEffect(() => {
    if (!value) {
      setIsEditAble(true);
    }
  }, [value]);

  const handleChange = (date: any, dateString: any) => {
    onChange(date, dateString);
    // Switch to preview mode after selecting a date if there's a value
    if (dateString) {
      setIsEditAble(false);
    }
  };

  const handleOpenChange = (open: boolean) => {
    // When the calendar closes and there's a value, switch to preview mode
    if (!open && value) {
      setIsEditAble(false);
    }
  };

  return isEditAble ? (
    <div className="date-picker-with-preview">
      <DatePicker
        size={size || 'default'}
        autoFocus={!!value}
        onChange={handleChange}
        onOpenChange={handleOpenChange}
        value={value ? dayjs(value) : undefined}
        format={['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD', 'DD.MM.YYYY', 'l']}
        disabled={disabled}
        allowClear={allowClear}
        tabIndex={tabIndex}
        popupClassName="date-picker-in-drawer"
      />
    </div>
  ) : (
    <span
      onClick={() => !disabled && setIsEditAble(true)}
      onFocus={() => !disabled && setIsEditAble(true)}
      className={classNames('input-with-preview', {
        'input-with-preview__disabled': disabled,
      })}
    >
      {value}
    </span>
  );
};

export default DatePickerWithPreview;
